export default {
      id: "men-icon-usage",
      viewBox: "0 0 11 14",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#men-icon",
      toString: function () {
        return this.url;
      }
    }